import { render, staticRenderFns } from "./m-edit-size.vue?vue&type=template&id=016923fd&scoped=true&"
import script from "./m-edit-size.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-edit-size.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-edit-size.vue?vue&type=style&index=0&id=016923fd&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016923fd",
  null
  
)

export default component.exports